import styled from 'styled-components';

export const SearchMonthListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 16px 16px 25px 16px;
  box-shadow: 0px 10px 30px rgba(58, 58, 58, 0.2);
`;

export const SearchPopoverWrapper = styled.div`
  & .react-tiny-popover-container {
    width: 100% !important;
    max-width: 570px !important;
  }
`;

export const ToggleYearButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: fit-content;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    justify-content: space-between;
  }
`;

export const ToggleYearButton = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.darkGrey};
  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.darkGrey : theme.palette.white};
  color: ${({ selected, theme }) =>
    selected ? theme.palette.white : theme.palette.darkGrey};
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.palette.darkGrey : theme.palette.iron};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    display: inline-block;
    text-align: center;
    padding: 7px 8px;
  }
`;

export const YearTabWrapper = styled.div`
  margin-right: auto;
`;

export const YearMonthsItems = styled.div`
  justify-content: initial;
  display: grid;
  grid-template-columns: repeat(3, 140px);
  margin-top: 20px;
  gap: 0 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X} - 1)`} {
    justify-content: initial;
    display: grid;
    grid-template-columns: repeat(3, 108px); /* 3 sütun */
    grid-auto-rows: 120px; /* Satır yüksekliği */
    max-height: calc(120px * 3 + 20px); /* 3 satır sınırı ve aralık */
    overflow-y: auto; /* Taşan öğeler için kaydırma */
    gap: 0 10px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    justify-content: initial;
    display: grid;
    grid-template-columns: repeat(3, 90px); /* 3 sütun */
    grid-auto-rows: 100px; /* Satır yüksekliği */
    overflow-y: auto; /* Taşan öğeler için kaydırma */
    gap: 0 10px;
  }
`;

export const YearMonthItem = styled.div`
  width: 119px;
  padding: 9px 10px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  margin-bottom: 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X} - 1)`} {
    width: 108px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 100%;
  }
`;
export const SelectWholeTermItem = styled.div`
  display: flex;
  justify-content: wrap;
  align-items: center;
`;

export const MobileDrawerItemWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.white};
`;

export const MobileSearchDrawerContent = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 33px 1fr 72px;
  padding: 24px 15px;
`;

export const MobileApplyButton = styled.button`
  width: 100%;
  padding: 11px 24px;
  background-color: ${({ theme }) => theme.palette.red};
  display: inline-block;
  text-align: center;
  color: ${({ theme }) => theme.palette.white};
  font-weight: 700;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  height: fit-content;
  margin-top: auto;
`;
